import {createSelector} from 'reselect'

import {usersSelector} from '../../../../data/users.js'
import {apiKeysSelector} from '../../../../data/apiKeys.js'
import {useMemo} from 'react'
import {useSelector} from '../../../../store.js'

const isEmailLikeRegex = /^.+@.+$/
const isEmailLike = (email) => email.match(isEmailLikeRegex) !== null

const isAPIKeyRegex = /^api_user_[^@]+$/
const isAPIKey = (email) => email.match(isAPIKeyRegex) !== null

const isOrdoroRegex = /^(user|dog_ipa|system|task)@ordoro.com$/
const isOrdoro = (email) => email.match(isOrdoroRegex) !== null

function makeUserNameFromEmailSelector(email) {
  const type =
    (isOrdoro(email) && 'system_user') ||
    (isEmailLike(email) && 'user') ||
    (isAPIKey(email) && 'api_user') ||
    null

  makeUserNameFromEmailSelector.cache[email] ||= createSelector(
    usersSelector,
    apiKeysSelector,
    (users, apiKeys) => {
      if (type === 'system_user') {
        return 'System User'
      }

      if (type === 'user') {
        const user = Object.values(users).find((user) => user.email === email)

        if (user) {
          return `${user.name} (${user.email})`
        }
      }

      if (type === 'api_user') {
        const user = Object.values(users).find((user) => user.email === email)

        if (user && user.is_api_user) {
          const apiKey = Object.values(apiKeys).find(
            (apiKey) => apiKey.user_id === user.id,
          )

          if (apiKey) {
            return apiKey.name
          }
        }
      }

      return email
    },
  )

  return makeUserNameFromEmailSelector.cache[email]
}
makeUserNameFromEmailSelector.cache = {}

/**
 * The user that made the comment
 *
 * @param {Object} props
 * @param {String} props.email
 * @returns {React.ReactNode}
 */
export default function User({email}) {
  const userNameFromEmailSelector = useMemo(
    () => makeUserNameFromEmailSelector(email),
    [email],
  )
  const name = useSelector(userNameFromEmailSelector)

  if (!name) {
    return null
  }

  return (
    <div className="attr--timeline-point">
      <em>
        {'– '}
        {name}
      </em>
    </div>
  )
}
